import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UpdateUserAddressComponent } from './update-user-address/update-user-address.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {
    MatAutocompleteModule,
    MatButtonModule,
    MatDialogModule,
    MatFormFieldModule,
    MatSelectModule
} from '@angular/material';
import {CameraDirectiveModule} from '../../directives/camera-directive.module';



@NgModule({
  declarations: [UpdateUserAddressComponent],
    imports: [
        CommonModule,
        ReactiveFormsModule,
        FormsModule,
        MatFormFieldModule,
        MatSelectModule,
        MatButtonModule,
        MatDialogModule,
        CameraDirectiveModule,
        MatAutocompleteModule
    ]
})
export class UserAddressModule { }
